import { useTranslation } from 'react-i18next';
import { Checkbox } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useGetCountriesNew } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { corrAddressListItem } from '../ChangeContactInformation';

// import styled from 'styled-components';
export const CorrespondenceCard = (props: {
  policyTypesObject: corrAddressListItem[];
  correspondencePolicyNo2: string[]; //現在是res 選擇的corr的list
}) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance(); //獲取的是props.form的意思
  const { token } = useKeycloakReady();

  const [residentialAddressCountry, setresidentialAddress5] = useState('');
  // const [ContactInformation, setContactInformation] = useState('');
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token || '',
    '',
    '2',
  );
  const myCountryList = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
    };
  });
  // const corresCountryList = countriesDataList?.correspondenceCountries.map((item) => {
  //   return {
  //     label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
  //     value: item.t3645Alpha3Country,
  //     sanctionLevel: item.sanctionLevel,
  //   };
  // });
  useEffect(() => {
    shouldFecthGetCountry(true);
    console.log(residentialAddressCountry);
  }, [shouldFecthGetCountry, residentialAddressCountry]);
  useEffect(() => {
    const a = myCountryList?.find((item) => item.value === form.getFieldValue('residentialAddress5'))?.label;
    if (a) {
      setresidentialAddress5(a);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [setresidentialAddress5, myCountryList, form]);
  // const {
  //   shouldFetch: shouldFecthDrop,
  //   data: dropData,
  //   // isLoading: dropDataisLoading,
  // } = usePolicyDropDown('usePolicyDropDown', token || '');
  // const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  // useEffect(() => {
  //   shouldFecthDrop(true);
  // }, [shouldFecthDrop]);
  // const dropDatanew = dropData?.filter((item) => form.getFieldValue('selectedPolicy')?.includes(item.policyNumber));
  // dropDatanew?.map((item) => {
  //   policyTypesObject.push({
  //     label: i18n.language == 'en' ? item.productName : item.productNameTC,
  //     label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
  //     value: item.policyNumber,
  //   });
  // });
  // const policyNumbers: Array<string> = [];
  form.setFieldsValue({
    correspondencePolicyNo: [],
  });
  //選擇的corr list的值
  const CheckboxonChange = (e: CheckboxChangeEvent, item: string) => {
    if (e.target.checked) {
      form.getFieldValue('correspondencePolicyNo').push(item);
      console.log('correspondencePolicyNo', form.getFieldValue('correspondencePolicyNo'), form.getFieldsValue(true));
    } else {
      const index = form.getFieldValue('correspondencePolicyNo').indexOf(item);
      if (index !== -1) {
        form.getFieldValue('correspondencePolicyNo').splice(index, 1);
      }
    }
  };
  return (
    // <Row gutter={[0, { xs: 8, sm: 8, lg: 24 }]} style={{ display: 'grid' }} className="crossCheckbox">
    <div className="crossCheckbox" style={{ marginTop: '8px' }}>
      {props.policyTypesObject?.map((item, index) => (
        <div key={index + 'po'}>
          {props.correspondencePolicyNo2.includes(item.policyNumber) && (
            <div
              style={{
                background: '#E9573D',
                borderRadius: '20px',
                padding: '4px 8px',
                fontSize: '15px',
                fontFamily: 'Roboto700',
                color: '#FFF',
                display: 'inline-block',
                height: '24px',
                lineHeight: '17px',
                marginTop: '16px',
              }}
            >
              {t('life.MakeRequest.contact.updatedPending')}
            </div>
          )}
          {item.correspondenceAddressFlag === 'Y' && (
            <div
              style={{
                background: '#E9573D',
                borderRadius: '12px',
                padding: '4px 8px',
                fontSize: '15px',
                fontFamily: 'Roboto700',
                color: '#FFF',
                display: 'inline-block',
                height: '24px',
                lineHeight: '17px',
                marginTop: '16px',
              }}
            >
              {t('life.MakeRequest.contact.UnderReview')}
            </div>
          )}
          <Checkbox
            onChange={(e) => {
              CheckboxonChange(e, item.policyNumber);
            }}
            className="corrCardCheckBox"
            disabled={
              props.correspondencePolicyNo2.includes(item.policyNumber) || item.correspondenceAddressFlag === 'Y'
            }
            style={{ borderBottom: '1px solid #CCCCCC' }}
          >
            <div
              style={{
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto500',
                marginTop: '8px',
              }}
            >
              {i18n.language == 'en' ? item.productName : item.productNameTc}
            </div>
            <div
              style={{
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto500',
                marginBottom: '10px',
                borderBottom: '1px solid #CCCCCC',
              }}
            >
              {`${t('life.enquiry.policyNo')}${item.policyNumber}`}
            </div>
            <div style={{ fontSize: '17px', fontFamily: 'Roboto400', fontWeight: 'bold' }}>
              {t('life.MakeRequest.contact.currentAddress')}
            </div>
            <div
              key={index + item.corrAddress1 + 'corrAdd1'}
              style={{
                border: 'none',
                backgroundColor: 'transparent',
                fontSize: '17px',
                fontFamily: 'Roboto400',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {item.corrAddress1}
            </div>
            <div
              key={index + item.corrAddress2 + 'corrAdd2'}
              style={{
                border: 'none',
                backgroundColor: 'transparent',
                fontSize: '17px',
                fontFamily: 'Roboto400',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {item.corrAddress2}
            </div>
            <div
              key={index + item.corrAddress3 + 'corrAdd3'}
              style={{
                border: 'none',
                backgroundColor: 'transparent',
                fontSize: '17px',
                fontFamily: 'Roboto400',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {item.corrAddress3}
            </div>
            <div
              key={index + item.corrAddress4 + 'corrAdd4'}
              style={{
                border: 'none',
                backgroundColor: 'transparent',
                fontSize: '17px',
                fontFamily: 'Roboto400',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {item.corrAddress4}
            </div>
            {/* <div
              key={index + item.corrAddress5 + 'corrAdd5'}
              style={{
                border: 'none',
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {myCountryList?.find((i) => i.value === item.corrAddressCountry)?.label}
            </div> */}
          </Checkbox>
        </div>
      ))}
    </div>
    // </Row>
  );
};
